import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import * as PXBColors from '@brightlayer-ui/colors';
const chartLabelNameStyle = makeStyles(() =>
    createStyles({
        titleBoxContent: {
            fontSize: '14px',
            fontFamily: 'open sans',
            letterSpacing: 2,
            lineHeight: '20px',
            paddingBottom: 0,
        },
        icon: {
            float: 'right',
            color: 'gray',
        },
        infoicon: {
            fontSize: '16px',
            position: 'relative',
            top: '3px',
            cursor: 'pointer',
        },
        link: {
            fontWeight: 600,
            textTransform: 'none',
            textDecoration: 'none',
        },

        boxContent: {
            backgroundColor: PXBColors.black[800],
            width: 20,
            height: 20,
            marginBottom: '20px',
        },
        colorSpan: {
            position: 'absolute',
            margin: '0px 30px',
        },

        headerCont: {
            fontSize: '14px',
            fontFamily: 'open sans',           
            lineHeight: '20px',
            paddingBottom: 0,
        },
        alrmnotify: {
            backgroundColor: PXBColors.blue[50],
            padding: '10px',
            letterSpacing: 0,
            fontSize: '12px',
        },
        alarmSuggBox: {
            backgroundColor: PXBColors.blue[50],          
            letterSpacing: 0,          
            width:'100%',
            marginBottom:'5px'
        },
        thumup: {
            fontSize: '20px',
            marginRight: '30px',
            cursor: 'pointer',
            color: PXBColors.blue[500]
        },
        thumdw: {
            fontSize: '20px',
            cursor: 'pointer',
            color: PXBColors.blue[500]
        }, 
        alarmHeaderContent: {
            backgroundColor: PXBColors.white[50],
            borderBottom: '1px solid gray',
            boxShadow: '0px 0px 6px 0px',
            marginBottom: '15px',
            padding: '15px 0px',
        }, 
        SuggTitle: {

            float:'left', padding:'8px',
            fontSize:'13px', lineHeight:'20px'
        },
        SuggContent: {

            float:'right',
            margin:'10px 22px 10px 0px'

        }
       
    })
);
export default chartLabelNameStyle;
